import { ShieldCheck, User } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { IconButton } from '@/components/ui';
import { getGreeting } from '@/features/feed/utils';

interface FeedHeaderProps {
  userName?: string;
  isAdmin?: boolean;
}

export function FeedHeader({ userName, isAdmin }: FeedHeaderProps) {
  const { t } = useTranslation();
  const greeting = getGreeting(t);

  return (
    <header className="w-full bg-[#F4F2F2] border-b border-[#CAC7C7] sticky top-0 z-40">
      <div className="max-w-5xl mx-auto px-4 py-3 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="text-xl font-serif text-[#2E2A23] flex-shrink-0">
          Newsletter
        </Link>

        {/* Greeting - Centered */}
        <p className="text-[#888185] text-sm absolute left-1/2 -translate-x-1/2 hidden sm:block">
          {greeting}
          {userName && <span className="font-medium text-[#2E2A23]">, {userName}</span>}
        </p>

        {/* Actions */}
        <div className="flex items-center gap-1 flex-shrink-0">
          <Link to="/profile">
            <IconButton aria-label={t('common.profile')}>
              <User className="w-5 h-5" />
            </IconButton>
          </Link>
          {isAdmin && (
            <Link to="/admin">
              <IconButton aria-label="Admin">
                <ShieldCheck className="w-5 h-5" />
              </IconButton>
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
